import { BehaviorSubject } from 'rxjs';

export const localizationService = {
  currentLang$: new BehaviorSubject('EN'),
  setUpLocalization: () => {},
};

export const getText = (arText, enText) => localizationService.currentLang$.value === 'AR' ? arText : enText;
